import {
    Button,
    CircularProgress,
    TextField,
    InputAdornment,
    IconButton,
} from "@mui/material";
import { AddLink, ContentCopy } from "@mui/icons-material";
import useEventCreatorScanningLink from "../hooks/useEventCreatorScanningLink";
import { H4 } from "../../../../../../themes/typography";

function EventCreatorScanningLink() {
    const {
        loading,
        handleGenerateLink,
        handleCopyLink,
        handleRegenerateLink,
        eventCreatorLink
    } = useEventCreatorScanningLink();

    return (
        <div className="invoice-info-main-container">
            <div id="personal-info-form">
                <div className="invoice-info-header">
                    <div className="invoice-info-title">
                        <span className="invoice-info-icon">
                            <AddLink color="secondary" sx={{ fontSize: '1.75rem' }} />
                        </span>
                        <H4 fontWeight={600}>
                            Event Creator Scanning Link
                        </H4>
                    </div>
                </div>
                <div className="invoice-info-body">

                    <div className="invoice-info-details">
                        <div className="invoice-info-two-inputs">
                            <div className="invoice-info-input-field">
                                <TextField
                                    fullWidth
                                    id="scanningLink"
                                    name="scanningLink"
                                    placeholder="Your scanning link will appear here"
                                    readOnly
                                    value={eventCreatorLink}
                                    slotProps={{
                                        input: {
                                            endAdornment: eventCreatorLink !== null && (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        edge="end"
                                                        onClick={handleCopyLink}
                                                    >
                                                        <ContentCopy />
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }
                                    }}
                                />
                            </div>

                            <div className="invoice-info-input-field" style={{ display: 'flex', alignItems: 'center' }}>

                                {eventCreatorLink === null && (
                                    <Button
                                        variant="main"
                                        onClick={handleGenerateLink}
                                        disabled={loading}
                                    >
                                        Generate Link {loading && (
                                            <CircularProgress
                                                size={20}
                                                sx={{
                                                    marginLeft: '0.75rem',
                                                    color: 'var(--primary-color)'
                                                }}
                                            />
                                        )}
                                    </Button>
                                )}

                                {eventCreatorLink !== null && (
                                    <Button
                                        variant="main"
                                        onClick={handleRegenerateLink}
                                        disabled={loading}
                                    >
                                        Regenerate Link {loading && (
                                            <CircularProgress
                                                size={20}
                                                sx={{
                                                    marginLeft: '0.75rem',
                                                    color: 'var(--primary-color)'
                                                }}
                                            />
                                        )}
                                    </Button>
                                )}

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default EventCreatorScanningLink